/**
 *
 * @type {{courses: string, submit: string, password_label: string, about: string, create_an_account: string, my_profile: string, required: string, log_in: string, email_label: string, country_label: string, existing_user: string, explore_courses: string, sign_in: string, sign_out: string}}
 */
const common = {
  app_title: 'IA Learn',
  explore_courses: 'Explore Courses',
  create_an_account: 'Create an account',
  existing_user: 'Existing user?',
  log_in: 'Log in',
  sign_in: 'Sign in',
  sign_out: 'Sign out',
  my_profile: 'My Profile',
  courses: 'Courses',
  about: 'About',
  submit: 'Submit',
  email_label: "Email Address",
  country_label: "Country",
  required: 'All fields required',
  password_label: 'Password',
  undo: "Undo",
  retry: "Retry",
  course_sequence_name: 'Course {sequence}: {name}',
  newest: 'Newest',
  most_popular: 'Most Popular',
  first_name_label: 'First Name',
  last_name_label: 'Surname',
  role_label: 'Role',
  role_name_label: 'Role Name',
  photo: 'Photo',
  upload_new: 'Upload new',
  continue_: 'Continue',
  required_field_message: 'This field is required',
  dismiss: 'Dismiss',
  expired_session_message: 'Your session has expired. Please log in again',
  saved: 'Saved'
};

/**
 *
 * @type {{email_label: string, password_label: string, or_register_an_account: string, h1: string, forgot_password: string}}
 */
const login_modal = {
  email_label: common.email_label,
  h1: 'Please Sign In to Continue',
  forgot_password: 'Forgot password?',
  password_label: common.password_label,
  or_register_an_account: 'or Register an Account'
};

/**
 *
 * @type {{notifications: string}}
 */
const nav = {
  help: 'Help',
  courses: 'Courses',
  about_us: 'About Us',
  my_courses: 'My Courses',
  my_profile: 'My Profile',
  terms_of_use: 'Terms of Use',
  notifications: 'Notifications',
  privacy_policy: 'Privacy Policy',
  select_language: 'Select Language',
  bcl_institute: 'Immunization Academy',
};

/**
 *
 * @type {string}
 */
const footer_copy = 'IA Learn, part of the Immunization Academy, is a learning platform that offers opportunities for in-depth study and certification in key immunization topics. Each of the courses on IA Learn is completely online, self-paced, and free. Individuals may learn wherever and whenever is convenient.';

/**
 *
 * @type {string[][]}
 */
const help_page = {
  h1: 'Help',
  h2: 'Frequently Asked Questions',
  faq: [
    ['How do I sign up for courses?', 'Click on the yellow “Enroll” button. You may sign up for as many courses as you like. The first time you click the Enroll button, you will provide some information about you, your role and location. Then you can begin taking the course.'],
    ['Who is this training meant for?', 'All training is geared toward immunization professionals. Some courses may be more appropriate for immunization managers -- people who are responsible for overseeing the EPI program in their geographic area -- while other courses are targeted toward health workers.'],
    ['Will I receive certification for taking a course?', 'Yes, if you complete a course and pass the assessment(s), you will receive a certificate from The BCL Institute for Learning in Global Health. You will need to score at least 80% in order to pass. You will receive a certificate for each course you complete. For example, if you complete three courses, you will receive three separate certificates.'],
    ['How do I access my certificate?', 'After you pass the assessment for a course, you will see the course listed on your dashboard under "Completed Courses." Beside the course name, you will see a button to click to download your certificate.'],
    ['What are the technology requirements for this online course?', 'You will need to be connected to the internet to take a course. In addition, these courses are designed to be taken on a desktop or laptop computer using a recent version of Chrome, Safari or Firefox.'],
  ],
  contact_us: 'Contact Us',
  p: 'If you have a problem using IA Learn that has not been addressed above, please send an email with your question to <a href="mailto:info@immunizationacademy.com" class="font-bold">info@immunizationacademy.com</a>.'
};

const whatsapp_promo = {
  h1: 'Join Us on Facebook',
  p: 'Follow Immunization Academy on Facebook to receive timely updates, member stories, and connect with others around the world. <a href="https://fb.com/ImmunizationAcademy" target="_blank" class="whitespace-no-wrap">https://fb.com/ImmunizationAcademy</a>'
};

/**
 *
 */
export default {
  nav,
  ...common,
  help_page,
  login_modal,
  footer_copy,
  whatsapp_promo,
}
